import { useMemo } from 'react'

// Environment → monolith host (dev→dev11, uat→tests, int→int01).
export const useMonolithBaseUrl = () => {
  return useMemo(() => {
    const hostname = window.location.hostname
    if (hostname.includes('localhost') || hostname.includes('dev')) {
      return 'https://dev11.icebergfinance.ca'
    }
    if (hostname.includes('uat')) {
      return 'https://tests.icebergfinance.ca'
    }
    if (hostname.includes('int')) {
      return 'https://int01.icebergfinance.ca'
    }
    return 'https://secure.icebergfinance.ca' // prod fallback
  }, [])
}
